module.exports = __webpack_public_path__ + "static/media/Brunch2023.ce682ce1.pdf";